import React, { useState } from "react";
import DefaultAvatar from "utils/DefaultAvatar";
import jsDig from "utils/jsDig";
import { CircleFill, Gear, SquareFill, Tv, PersonPlusFill, PlusCircleFill } from "react-bootstrap-icons";
import { Container, Row, Col, OverlayTrigger, Button, Tooltip } from "react-bootstrap";
import Avatar from "@material-ui/core/Avatar";
import { Truncate } from "@shopify/polaris";
import $ from "jquery";
const websitePlatforms = ["Shopify", "BigCommerce", "Magento", "Wordpress", "Other"];
const backgroundColors = ["#d97358", "#F2C010", "#427BFF", "#43B995"];
const sections = ["display", "search", "seo", "social", "video"];
const permissionsLabel = [
  "No changes allowed, or exceptions only",
  "All changes require prior approval",
  "Free to make changes with follow-up email summary",
  "Free to make changes, no notification necessary",
];

export default function TopFlyout(props) {
  const showOrNot = window.innerWidth > 1530 ? false : true;

  let shopLogo = require("images/shop-logo.png");
  shopLogo = <img className="mb-2" src={`/datapulse${shopLogo}`} />;
  let bcLogo = require("images/bg-logo.png");
  bcLogo = <img className="mb-2" src={`/datapulse${bcLogo}`} />;
  const [collapse, setCollapse] = useState(showOrNot);
  let teamSupports = [];
  let teamLeads = [];
  sections.forEach((section) => {
    if (props[`${section}_section`].account_leads) teamLeads.push(...props[`${section}_section`].account_leads);
    if (props[`${section}_section`].account_supports) teamSupports.push(...props[`${section}_section`].account_supports);
  });
  const toggleCollapse = (event) => {
    let btn = $(event.target);
    btn.next(".collapse").collapse("toggle");
    setCollapse(!collapse);
  };
  let chevronLeft = require("images/icons/chevron-left.png");
  chevronLeft = <img src={`/datapulse${chevronLeft}`} />;
  let chevronRight = require("images/icons/chevron-right.png");
  chevronRight = <img src={`/datapulse${chevronRight}`} />;
  let chevronTop = require("images/icons/chevron-top.png");
  chevronTop = (
    <button onClick={toggleCollapse} className="react-collapser rectangle-77">
      <img className="chevronTop" src={`/datapulse${chevronTop}`} />
    </button>
  );
  let chevronDown = require("images/icons/chevron-down.png");
  chevronDown = (
    <button onClick={toggleCollapse} className="react-collapser rectangle-77">
      <img className="chevronDown" src={`/datapulse${chevronDown}`} />;
    </button>
  );
  const barShow = collapse ? "barHiden" : "barShow";
  let departments = [];
  const arrayOfUsers = Object.entries(props.users).map((e) => ({
    [e[0]]: e[1],
  }));
  const avatarTeamLead = arrayOfUsers.map((personal, index) => {
    const info = Object.entries(personal)[0];
    const email = info[0];
    if (teamLeads.includes(email)) {
      const personalInfo = info[1];
      const department = personalInfo.department;
      const personalInfoToolTip = `<div class="personalTooltip" key=${index}>
              <h6>${personalInfo.name}</h6>
              <div class="personalInfo">
                  <p>${props.organization.name}</p>
                  <div><hr class="vertical"/></div>
                  <p>${personalInfo.job_title ? personalInfo.job_title : "N/A"}</p>
              </div>
              <p>${email}</p>
              <p>Tel: ${personalInfo.phone_number}</p>
              </div>`;
      let legendColor = "black";
      if (department == "both_departments") legendColor = "#2c345b";
      if (department == "ppc_department") legendColor = "#3291C1";
      if (department == "seo_department") legendColor = "#42BA96";
      if (department == "dev_department") legendColor = "#DBB13B";
      if (!departments.includes(personalInfo.department)) departments.push(personalInfo.department);
      return (
        <button type="button" key={index} className="" data-html="true" data-toggle="tooltip" title={personalInfoToolTip}>
          {personalInfo.avatar ? (
            <Avatar
              src={personalInfo.avatar}
              style={{
                width: window.innerWidth > 1550 ? "30px" : "25px",
                height: window.innerWidth > 1550 ? "30px" : "25px",
                borderStyle: "solid",
                borderWidth: "2px",
                borderColor: `${legendColor}`,
              }}
            />
          ) : (
            <DefaultAvatar dim={window.innerWidth > 1550 ? "30x30" : "25x25"} name={info[1].name} className="avatar" department={info[1].department} />
          )}
        </button>
      );
    }
  });
  let arrayOfTeamSupport = [];
  arrayOfUsers.forEach((user, index) => {
    const info = Object.entries(user)[0];
    const email = info[0];
    if (teamSupports.includes(email)) {
      arrayOfTeamSupport.push(user);
    }
  });
  const avatarTeamSupport =
    arrayOfTeamSupport.length < 3 ? (
      arrayOfUsers.map((personal, index) => {
        const info = Object.entries(personal)[0];
        const email = info[0];
        if (teamSupports.includes(email)) {
          const personalInfo = info[1];
          const department = personalInfo.department;
          const personalInfoToolTip = `<div class="personalTooltip" key=${index}>
        <h6>${personalInfo.name}</h6>
        <div class="personalInfo">
            <p>${props.organization.name}</p>
            <div><hr class="vertical"/></div>
            <p>${personalInfo.job_title ? personalInfo.job_title : "N/A"}</p>
        </div>
        <p>${email}</p>
        <p>Tel: ${personalInfo.phone_number}</p>
        </div>`;
          let legendColor = "black";
          if (department == "both_departments") legendColor = "#2c345b";
          if (department == "ppc_department") legendColor = "#3291C1";
          if (department == "seo_department") legendColor = "#42BA96";
          if (department == "dev_department") legendColor = "#DBB13B";
          if (!departments.includes(personalInfo.department)) departments.push(personalInfo.department);
          return (
            <button type="button" style={{ padding: "2px" }} key={index} data-html="true" data-toggle="tooltip" title={personalInfoToolTip}>
              {personalInfo.avatar ? (
                <Avatar
                  src={personalInfo.avatar}
                  style={{
                    width: window.innerWidth > 1550 ? "30px" : "25px",
                    height: window.innerWidth > 1550 ? "30px" : "25px",
                    borderStyle: "solid",
                    borderWidth: "2px",
                    borderColor: `${legendColor}`,
                  }}
                />
              ) : (
                <DefaultAvatar dim={window.innerWidth > 1550 ? "30x30" : "25x25"} name={info[1].name} className="avatar" />
              )}
            </button>
          );
        }
      })
    ) : (
      <>
        {arrayOfTeamSupport.slice(0, 2).map((personal, index) => {
          const info = Object.entries(personal)[0];
          const email = info[0];
          if (teamSupports.includes(email)) {
            const personalInfo = info[1];
            const department = personalInfo.department;
            const personalInfoToolTip = `<div class="personalTooltip" key=${index}>
        <h6>${personalInfo.name}</h6>
        <div class="personalInfo">
            <p>${props.organization.name}</p>
            <div><hr class="vertical"/></div>
            <p>${personalInfo.job_title ? personalInfo.job_title : "N/A"}</p>
        </div>
        <p>${email}</p>
        <p>Tel: ${personalInfo.phone_number}</p>
        </div>`;
            let legendColor = "black";
            if (department == "both_department") legendColor = "#2c345b ";
            if (department == "ppc_department") legendColor = "#3291C1";
            if (department == "seo_department") legendColor = "#42BA96";
            if (department == "dev_department") legendColor = "#DBB13B";
            if (!departments.includes(personalInfo.department)) departments.push(personalInfo.department);
            return (
              <button
                type="button"
                style={{ padding: "2px", background: "transparent" }}
                key={index}
                data-html="true"
                data-toggle="tooltip"
                title={personalInfoToolTip}>
                {personalInfo.avatar ? (
                  <Avatar
                    src={personalInfo.avatar}
                    style={{
                      width: window.innerWidth > 1550 ? "30px" : "25px",
                      height: window.innerWidth > 1550 ? "30px" : "25px",
                      borderStyle: "solid",
                      borderColor: `${legendColor}`,
                      backgroundColor: "transparent",
                    }}
                  />
                ) : (
                  <DefaultAvatar
                    dim={window.innerWidth > 1550 ? "30x30" : "25x25"}
                    name={info[1].name}
                    className="avatar"
                    department={info[1].department}
                    style={{ backgroundColor: "transparent" }}
                  />
                )}
              </button>
            );
          }
        })}
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip>
              <ul style={{ padding: "2px" }}>
                {" "}
                {arrayOfTeamSupport.slice(2, arrayOfUsers.length).map((personal, index) => {
                  const info = Object.entries(personal)[0];
                  const email = info[0];

                  if (teamSupports.includes(email)) {
                    const personalInfo = info[1];
                    return (
                      <li style={{ listStyleType: "none" }} key={index}>
                        <p className="personalTooltip">
                          {personalInfo.job_title}: <h6>{personalInfo.name}</h6>
                        </p>
                      </li>
                    );
                  }
                })}
              </ul>
            </Tooltip>
          }>
          <PlusCircleFill />
        </OverlayTrigger>
      </>
    );
  const clientUsers = props.client_account.client_users;

  const clientUsersOverage = !clientUsers ? [...Array(4)]: props.client_account.client_users.filter((el, idx) => idx > 6)


  
  const arrayOfClients = Object.entries(props.client_users).map((e) => ({
    [e[0]]: e[1],
  }));



  const renderAvatarClients = !clientUsers ? [...Array(4)]: [...Array(Math.ceil(clientUsers.length / 4)).keys()].map((item, idx) => {
    if (idx === 0) {
      return (
        <Row>
{arrayOfClients.filter((el, i) => {
  return clientUsers && clientUsers.includes(Object.entries(el)[0][0])

}).map((personal, index) => {
      const info = Object.entries(personal)[0];
     
        const personalInfo = `<div class="personalTooltip" key=${index}>
          <h6>${info[1].name}</h6>
          <div class="personalInfo">
              <p>${props.company_name}</p>
              <div><hr class="vertical"/></div>
              <p>${info[1].job_title ? personal.job_title : "N/A"}</p>
          </div>
          <p>${info[0]}</p>
          <p>Tel: ${info[1].phone_number}</p>
      </div>`;
      
      if (index < 4) {
        return (
          <button type="button" key={index} className="" data-html="true" data-toggle="tooltip" title={personalInfo}>
            <DefaultAvatar dim={window.innerWidth > 1550 ? "30x30" : "25x25"} name={info[1].name} className="avatar" department={info[1].department} />
          </button>
        );
      }
      
    })}
        </Row>
      )
    }
    if (idx === 1) {
      return (
<Row>
{arrayOfClients.filter((el, i) => {
  return clientUsers && clientUsers.includes(Object.entries(el)[0][0])

}).map((personal, index, arr) => {
      const info = Object.entries(personal)[0];
     
        const personalInfo = `<div class="personalTooltip" key=${index}>
          <h6>${info[1].name}</h6>
          <div class="personalInfo">
              <p>${props.company_name}</p>
              <div><hr class="vertical"/></div>
              <p>${info[1].job_title ? personal.job_title : "N/A"}</p>
          </div>
          <p>${info[0]}</p>
          <p>Tel: ${info[1].phone_number}</p>
      </div>`;

      const lastInfo = `<div class="personalTooltip" key=${index}>
         
          <div class="additionalUsers">
              <p>${props.company_name}</p>
              <p>Additional Users</p>
              <div><hr class="vertical"/></div>
              <div>
              <ul class="ulNumber">
              ${clientUsersOverage.map(el => `<li>    ${el} </li>`).join('')}
              </ul>
              </div>
              
          </div>
   
      </div>`;
      
      if (index > 3 && index < 8 && arr.length <= 8) {
        return (
          <button type="button" key={index} className="" data-html="true" data-toggle="tooltip" title={personalInfo}>
            <DefaultAvatar dim={window.innerWidth > 1550 ? "30x30" : "25x25"} name={info[1].name} className="avatar" department={info[1].department} />
          </button>
        );
      }
      if (index > 3 && index < 7 && arr.length > 8) {
        return (
          <button type="button" key={index} className="" data-html="true" data-toggle="tooltip" title={personalInfo}>
            <DefaultAvatar dim={window.innerWidth > 1550 ? "30x30" : "25x25"} name={info[1].name} className="avatar" department={info[1].department} />
          </button>
        );
      }
      if (index === 8 && arr.length > 8) {
        return (
          <button type="button" key={index} className="tdnone" data-html="true" data-toggle="tooltip" title={lastInfo}>
            <DefaultAvatar  bg="#2c345b" dim={window.innerWidth > 1550 ? "30x30" : "25x25"} name={`+ ${arr.length - 7}`} className="avatar" />
          </button>
        );
      }
      
    })}
        </Row>
      )
    }

  })  
  const renderDepartmentsLegends = departments.map((department, index) => {
    department = department ? department.split("_")[0].toUpperCase() : ""
    let legendColor = "black";
    if (department == "BOTH") legendColor = "#2c345b";
    if (department == "PPC") legendColor = "#3291C1";
    if (department == "SEO") legendColor = "#42BA96";
    if (department == "DEV") legendColor = "#DBB13B";
    return (
      <li key={index}>
        <SquareFill size={8} color={legendColor} />
        {department == "NO" ? <p>N/A</p> : <p>{department}</p>}
      </li>
    );
  });
  let accessLegends = [];

  const accessNames = props.client_account.team_access ? Object.keys(props.client_account.team_access) : [];

  const accessLevels = props.client_account.team_access ? Object.values(props.client_account.team_access) : [];
  accessLevels.forEach((access) => {
    if ((access.Full == "1" || access["Completed setup"] == "1") && !accessLegends.includes("Full")) accessLegends.push("Full");
    if (access.Restricted == "1" && !accessLegends.includes("Restricted")) accessLegends.push("Restricted");
  });
  const renderAccessesList = accessNames.map((access, index) => {
    let accessColor = "#2c345b ";
    if (accessLevels[index]["Full"] == "1" || accessLevels[index]["Completed setup"] == "1") accessColor = "#42BA96";
    if (Object.values(props.client_account.team_access[`${access}`]).includes("1")) {
      return (
        <li key={index}>
          <CircleFill size={6} color={accessColor} />
          <p>{access}</p>
        </li>
      );
    }
  });
  const renderAccessesLegends = accessLegends.map((access, index) => {
    //default color for Restricted access
    let accessColor = "#2c345b ";
    if (access == "Full") accessColor = "#42BA96";
    return (
      <li key={index}>
        <CircleFill size={8} color={accessColor} />
        <p>{access}</p>
      </li>
    );
  });
  const permissionsExplainations = [
    "No changes allowed, or exceptions only",
    "All changes require prior approval",
    "Free to make changes with follow-up email summary",
    "Free to make changes, no notification necessary",
  ];
  const comfortLevel = (
    <Tooltip style={{ zIndex: "2001", width: "20vw" }}>
      <Container style={{ maxWidth: "none", width: "100%" }}>
        <Row>
          <Col className="pt-2" xs={4}>
            <h6 style={{ textAlign: "left" }}>Global:</h6>
          </Col>
          {props.client_account.global_website_permissions != null && (
            <>
              <Col style={{ width: "20px", flexGrow: "0" }} xs={2}>
                <Avatar
                  type="button"
                  className="overall-permission"
                  style={{
                    backgroundColor: backgroundColors[props.client_account.global_website_permissions - 1],
                  }}>
                  {props.client_account.global_website_permissions}
                </Avatar>
              </Col>
              <Col style={{ flexGrow: "3", margin: "auto" }} xs={6}>
                <p style={{ fontSize: "10px", position: "relative", top: "3px", textAlign: "left" }} className="noMargin">
                  {permissionsExplainations[props.client_account.global_website_permissions - 1]}
                </p>
              </Col>
            </>
          )}
        </Row>
        <hr
          style={{
            color: "#E1E1E1",
            backgroundColor: "#E1E1E1",
            height: 0.1,
            borderColor: "#E1E1E1",
            marginTop: "8px",
            display: props.client_account.custom_website_permissions ? "inherit" : "none",
          }}
        />
        <Row style={{ display: props.client_account.custom_website_permissions ? "inherit" : "none" }}>
          <Col>
            <h6 style={{ textAlign: "left" }}>Custom:</h6>
          </Col>
        </Row>
        {props.client_account.custom_website_permissions &&
          props.client_account.custom_website_permissions.map((web, index) => (
            <Row key={index} style={{ marginBottom: "5px" }}>
              <Col xs={4}>
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    color: "#2c345b ",
                    textAlign: "left",
                  }}>
                  {web.website}
                </p>
              </Col>
              <Col style={{ width: "20px", flexGrow: "0" }} xs={2}>
                <Avatar
                  className="custom-permissions"
                  type="button"
                  style={{
                    backgroundColor: backgroundColors[parseInt(web.permission) - 1],
                  }}>
                  {web.permission}
                </Avatar>
              </Col>
              <Col xs={6}>
                <p style={{ fontSize: "10px", position: "relative", top: "3px", textAlign: "left" }}>{permissionsLabel[parseInt(web.permission) - 1]}</p>
              </Col>
            </Row>
          ))}
      </Container>
    </Tooltip>
  );

  const clientWebsite = jsDig(["websites", "primary"], props.client_account) ? jsDig(["websites", "primary"], props.client_account) : "N/A";
  let websitePlatformLogo;
  if (props.client_account.website_platform === 0) {
    websitePlatformLogo = shopLogo;
  } else if (props.client_account.website_platform === 1) {
    websitePlatformLogo = bcLogo;
  } else {
    websitePlatformLogo = websitePlatforms[`${props.client_account.website_platform}`];
  }

  return (
    <div className="flyoutComponent">
      <div className={` react-flyout-collapser ${barShow}`}>{collapse ? chevronDown : chevronTop}</div>
      {/* remove class collapse on below for animation purposes */}
      <div className={`topFlyout show`} style={{ marginTop: collapse ? "-250px" : "0px", transition: "margin .25s cubic-bezier(0.65, 0, 0.15, 1)" }}>
        <div className="client">
          <div style={{ height: "80px", width: "75%", margin: "auto" }}>
            {props.client_logo ? (
              <img
                src={props.client_logo}
                style={{
                  maxWidth: "90%",
                  maxHeight: "100%",
                  paddingBottom: "10px",
                  width: "auto",
                  height: "auto",
                }}
              />
            ) : (
              <h5 style={{ paddingBottom: "10px", height: "90px" }}>{props.company_name}</h5>
            )}
          </div>

          <div className="group">
            {props.search_section.enabled === true ||
            props.display_section.enabled === true ||
            props.video_section.enabled === true ||
            props.social_section.enabled === true ? (
              <div className="rectangle-75 ">
                <a href="/datapulse/ppc-dashboard#ppc">
                  <p>PPC</p>
                </a>
              </div>
            ) : undefined}
            {props.seo_section && props.seo_section.enabled === true && (
              <div className="rectangle-76">
                <a href="/datapulse/seo-dashboard">
                  <p>SEO</p>
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="vertical-separator">
          <hr className="vertical" />
        </div>
        <div id="top-Flyout-Indicators" className="carousel slide" data-ride="carousel" data-interval="false">
          <ul className="carousel-indicators">
            <li data-target="#top-Flyout-Indicators" data-slide-to="0" className="active">
              <p>Account</p>
            </li>
            <li data-target="#top-Flyout-Indicators" data-slide-to="1">
              <p>Team</p>
            </li>
            <a className="carousel-control-prev" href="#top-Flyout-Indicators" role="button" data-slide="prev">
              {chevronLeft}
            </a>
          </ul>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="account">
                <div className="webPlatform">
                  <h6>Website Platform:</h6>
                  {websitePlatformLogo}
                  <div className="client-website">
                    <p>
                      <Tv />
                      &nbsp;&nbsp;
                      {clientWebsite == "N/A" ? (
                        <a>{clientWebsite}</a>
                      ) : (
                        <a href={clientWebsite} target="_blank">
                          {clientWebsite}
                        </a>
                      )}
                    </p>
                  </div>
                </div>

                <div className="POC">
                  <h6>Client Users:</h6>
                  {renderAvatarClients}
                </div>
                <div className="comfortLevel">
                  <h6>Comfort Level with Site Changes:</h6>
                  {props.client_account.custom_website_permissions_enabled ? (
                    <div className="comfortDetails">
                      <OverlayTrigger placement="bottom-start" delay={{ show: 250, hide: 400 }} overlay={comfortLevel}>
                        <Button variant="success">
                          {" "}
                          <DefaultAvatar
                            custom={true}
                            dim={window.innerWidth > 1550 ? "30x30" : "25x25"}
                            style={{ backgroundColor: "#30336A" }}
                            name="C"
                            className="avatar"
                          />
                        </Button>
                      </OverlayTrigger>
                      <div style={{ textAlign: "left" }}>
                        <p className="noMargin">Custom:</p>
                        <p className="noMargin">Hover for details</p>
                      </div>
                    </div>
                  ) : (
                    <Row style={{ width: "75%" }}>
                      {/* <Col className="noMargin">
                        <h6>Global:</h6>
                      </Col> */}
                      {props.client_account.global_website_permissions && (
                        <Row>
                          <Col xs={4} style={{ paddingRight: "0px" }}>
                            <Button>
                              {" "}
                              <DefaultAvatar
                                custom={true}
                                dim={window.innerWidth > 1550 ? "30x30" : "25x25"}
                                name={`${props.client_account.global_website_permissions}`}
                                className="avatar"
                              />
                            </Button>
                          </Col>

                          <Col xs={8} className="noMargin" style={{ paddingLeft: "0px" }}>
                            <p className="noMargin">{permissionsExplainations[props.client_account.global_website_permissions - 1]}</p>
                          </Col>

                          {/* <OverlayTrigger
                            placement="bottom-start"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                              <Tooltip style={{ zIndex: "2001", width: "20vw", padding: "5px" }}>
                                {permissionsExplainations[props.client_account.global_website_permissions - 1]}
                              </Tooltip>
                            }>
                            <Avatar
                              type="button"
                              style={{
                                backgroundColor: backgroundColors[props.client_account.global_website_permissions - 1],
                                width: "24px ",
                                height: "24px ",
                                color: "#eeeeee",
                                marginTop: "5px",
                                fontSize: "14px",
                                fontFamily: "visby-bold, arial, sans-serif",
                                paddingRight: "1px",
                                paddingTop: "1px",
                              }}>
                              {props.client_account.global_website_permissions}
                            </Avatar>
                          </OverlayTrigger> */}
                        </Row>
                      )}
                    </Row>
                  )}
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="team">
                <div className="teamLeads">
                  <h6>Team Lead(s):</h6>
                  <div className="d-flex">{avatarTeamLead}</div>
                </div>
                <div className="teamSupports">
                  <h6>Team Support:</h6>
                  <div className="d-flex">{avatarTeamSupport}</div>
                </div>
                <div className="departmentsLegend">
                  <ul style={{ paddingLeft: "5px" }}>{renderDepartmentsLegends}</ul>
                </div>
                <div className="vertical-separator-short">
                  <hr className="vertical" />
                </div>
                <div className="accessGranted">
                  <h6>Access Granted:</h6>
                  <ul>{renderAccessesList}</ul>
                </div>
                <div className="accessLegend">
                  <ul>{renderAccessesLegends}</ul>
                </div>
              </div>
            </div>
          </div>
          <a className="carousel-control-next" href="#top-Flyout-Indicators" role="button" data-slide="next">
            {chevronRight}
          </a>
        </div>
        <a className="nav-link gear" href="/datapulse/account-config" style={{ visibility: props.login_type ? "visible" : "hidden" }}>
          <Gear />
        </a>
        <br />
      </div>
    </div>
  );
}
